import { useNewIsLoggedIn } from "src/hooks/useIsLoggedIn";
import { BrandViewBrandCover } from "src/organisms/BrandViewBrandCover";
import type { BrandData } from "src/types/adapters/browse.type";
import { ShopType } from "src/types/graphql.d";

type BrandBannerProps = {
  brand: BrandData;
  genderId: ShopType | string;
};

function BrandBanner({
  brand,
  genderId,
}: BrandBannerProps): React.ReactElement {
  const { isLoggedIn } = useNewIsLoggedIn();

  return (
    <>
      {brand ? (
        <BrandViewBrandCover
          isLoggedIn={isLoggedIn}
          brand={brand}
          genderId={genderId as ShopType}
          noPadding
          fullWidth
        />
      ) : null}
    </>
  );
}

export { BrandBanner };
